module.exports = __webpack_public_path__ + "56a72668a791d1f58498743e62430f5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spinnin-klaw-video-poster.jpg
// module id = 552
// module chunks = 0